export default __webpack_public_path__ + "static/media/g7.3d332e2a.jpg";